<template>
    <div class="baseDetail">
        <div class="detailItem" v-for="(item,index) in data" :key="item.id">
            <div class="title">{{ item.name }} :</div>
            <template>
                <slot :name="item.key" :item="data[index]" v-if="item.type === 'custom'"></slot>
                <label v-else> {{ item.content }}</label>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailPage',
    props:[ 'detailData','fields' ],
    data() {
        return {
            data: [],
        }
    },
    methods: {
        dataHandle() {
            this.data = []
            for( let dataKey in this.detailData){
                
                this.fields.forEach(item=>{
                   if(item.key === dataKey) {
                       item.content = this.detailData[dataKey]
                       this.data.push(item)
                   }
                })
            }
            
        }
    },
    watch: {
       detailData (newV) {
            this.detailData = newV
            this.dataHandle()
       } 
    },
    created() {
        this.dataHandle()
    }
}
</script>

